import type { JSONContent } from "@tiptap/core";
import type { Category, Tag, UniqueDocIdentifier } from "./core/descriptors";
import type { CoreDocument } from "./core/documents";
import type { FAdvancedImage } from "./core/media";
import type { AsMapPayload, AsPayloadWithDraft } from "./utils";

export type CoreBlog = CoreDocument & {
  title?: string;
  description?: JSONContent | null;
  coverImage?: FAdvancedImage | null;
  categoryId?: Category["id"] | null;
  tagIds?: Tag["id"][] | null;
};

export type BlogMetadata = {
  slug: string;
  parentDocumentId?: string | null;
  childDocumentIds?: string[] | null;
  type: "blog";
  visibility: "public" | "private";
};

export type BlogList = AsMapPayload<FBlog>;

export const MAX_BLOG_NESTING = 3;

export enum BlogType {
  BLOG = "blog",
  CHAPTER = "chapter",
  PART = "part",
}

/* -------------------------------------------------------------------------- */
/*                             FIREBASE STRUCTURE                             */
/* -------------------------------------------------------------------------- */
export type FBlog = AsPayloadWithDraft<CoreBlog> & BlogMetadata & UniqueDocIdentifier;
